import { SearchIconContainer } from '../../mobile/search-box/styles';
import React from 'react';

const SearchIcon = () => {
  return (
    <SearchIconContainer>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.46785 14.9357C3.34088 14.9357 0 11.5948 0 7.46785C0 3.34088 3.34088 0 7.46785 0C11.5948 0 14.9357 3.34088 14.9357 7.46785C14.9357 11.5948 11.5948 14.9357 7.46785 14.9357ZM7.46785 1.47392C4.12697 1.47392 1.47392 4.12697 1.47392 7.46785C1.47392 10.8087 4.12697 13.4618 7.46785 13.4618C10.8087 13.4618 13.4618 10.8087 13.4618 7.46785C13.4618 4.12697 10.7105 1.47392 7.46785 1.47392Z"
          fill="#36354C"
        />
        <path
          d="M16.0181 16.9997C15.7233 16.9997 15.5268 16.9014 15.3302 16.7049L11.7928 13.1675C11.3998 12.7745 11.3998 12.1849 11.7928 11.7919C12.1859 11.3988 12.7754 11.3988 13.1685 11.7919L16.7059 15.3293C17.0989 15.7223 17.0989 16.3119 16.7059 16.7049C16.5094 16.9014 16.3128 16.9997 16.0181 16.9997Z"
          fill="#36354C"
        />
      </svg>
    </SearchIconContainer>
  );
};

export default SearchIcon;
